module.exports = __webpack_public_path__ + "img/varilux-comfort.05be06e8.svg";